// extracted by mini-css-extract-plugin
module.exports = {"floatRightbarWrap":"App_floatRightbarWrap__2EoAT"};